var sfxs = [
    { name: 'gem', sfx: null, filename: './sfx/gem.ogg' },
    { name: 'gem2', sfx: null, filename: './sfx/gem2.ogg' },
    { name: 'gem3', sfx: null, filename: './sfx/gem3.ogg' },
    { name: 'hurt', sfx: null, filename: './sfx/hurt.ogg' },
    { name: 'hurt2', sfx: null, filename: './sfx/hurt2.ogg' },
    { name: 'playerhurt', sfx: null, filename: './sfx/playerhurt.ogg' },
    { name: 'levelup', sfx: null, filename: './sfx/levelup.ogg' },
    { name: 'acid', sfx: null, filename: './sfx/acid.ogg' },
    { name: 'revive', sfx: null, filename: './sfx/revive.ogg' },
    { name: 'pause', sfx: null, filename: './sfx/pause.ogg' },
    { name: 'rumble', sfx: null, filename: './sfx/rumble.ogg' },
    { name: 'rumble2', sfx: null, filename: './sfx/rumble2.ogg' },
    { name: 'rumble3', sfx: null, filename: './sfx/rumble3.ogg' },
    { name: 'selection', sfx: null, filename: './sfx/selection.ogg' },
    { name: 'back', sfx: null, filename: './sfx/back.ogg' },
    { name: 'select', sfx: null, filename: './sfx/select.ogg' }
]
var sfxVolume = 0.45

function isPlaying(name) {
    let sf = getSfx(name)
    if (sf) {
        return !sf.paused || sf.currentTime && sf.currentTime < sf.duration
    }
    return false
}

function getSfx(name) {
    let sf = sfxs.filter(f => f.name === name)
    return sf.length > 0 ? sf[0].sfx : null
}


function playSfx(name, onEnded) {
    return new Promise((resolve, reject) => {
        try {
            let sf = sfxs.filter(f => f.name === name)
            if (sf.length > 0) {
                if (!isPlaying(name)) {
                    sf[0].sfx.volume = sfxVolume
                    if (onEnded) {
                        sf[0].sfx.onended = (e) => {
                            onEnded(e)
                            sf[0].sfx.onended = (e) => { resolve() }
                        }
                    } else {
                        sf[0].sfx.onended = (e) => { resolve() }
                    }
                    sf[0].sfx.play()
                } else {
                    sf[0].sfx.currentTime = 0
                }
            }
        } catch (e) {
            console.log('Error playing sfx', name, e)
        }
    })
}

function loadSfx(filename) {
    return new Promise((resolve, reject) => {
        let sf = new Audio(filename)
        sf.oncanplaythrough = (e) => {
            resolve(sf)
        }
        sf.onerror = (e) => {
            console.error(`Failed to load file ${filename}:`, e)
            reject(e)
        }
    })
}

function loadAllSfx() {
    return new Promise(async (resolveAll, rejectAll) => {
        let promises = []
        for (let i in sfxs) {
            let sfx = sfxs[i]
            promises.push(new Promise((resolve, reject) => loadSfx(sfx.filename).then(r => {
                sfx.sfx = r
                resolve(r)
            }).catch(e => {
                console.error('Failed to load', sfx.filename, e)
                rejectAll('Failed to load' + sfx.filename + ':' + JSON.stringify(e))
            })))
        }
        await Promise.allSettled(promises)
        resolveAll()
    })
}

export { loadAllSfx, loadSfx, playSfx, getSfx, isPlaying }